import {
  SET_LOADING,
  GET_UNFULFILL,
  GET_UNFULFILL_ERROR,
  GET_UNFULFILL_BY_ID,
} from "../types";

const FulfillmentReducer = (state, action) => {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        loading: true,
      };

    case GET_UNFULFILL:
      return {
        ...state,
        unfulfill: action.payload.unfulfill,
        loading: false,
      };

    case GET_UNFULFILL_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case GET_UNFULFILL_BY_ID:
      return {
        ...state,
        unfulfillAdded: action.payload.unfulfill,
        loading: false,
      };

    default:
      return state;
  }
};

export default FulfillmentReducer;